import { FclIcon, LclIcon } from '@freighthub/silhouette-core'

export const cargoTypesIconMap = {
  fcl: <FclIcon />,
  lcl: <LclIcon />,
}

export const cargoTypesTooltipMap = {
  fcl: 'common-cargo_type-fcl',
  lcl: 'common-cargo_type-lcl',
}
